module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAHlBMVEUAK4DOsyr90RbqhBzOESYAK3/YuSX80RbogB7OESbsj2vXAAAACXRSTlPUrNSs1P/G/8YgTiD5AAAAMUlEQVR4AWJkQAOMimgCQgLoKkIB7csxDQAAAAIg+6c2g6+DH0VRFEVRlN+iKIqSuRS1jSelBbrG1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ro.png
// module id = 9WS0
// module chunks = 0